import { useQuery } from 'react-query';
import { QueryKeys } from '../QueryKey';
import axiosInstance from '../axiosConfig';

export function useGetReviewedCompanyRequests(userId: string) {
    const getReceivedCompanyRequests = async (userId: string) => {
        const response = await axiosInstance.get(
            `/api/company-reviews-requests/reviewed/${userId}`
        );
        const data = await response.data;
        return data;
    };
    return useQuery(QueryKeys.RetrieveCompanyReceivedReviewRequest, () =>
        getReceivedCompanyRequests(userId),
    );
}
